<!--  -->
<template>
  <div class="Certification">
    <div class="Certification_main">
      <h1>{{ Certification_title }}</h1>
      <swiper
        :auto-update="true"
        class="certification-swiper PC"
        ref="certificationSwiper"
        :options="swiperOption4"
      >
        <swiper-slide
          class="swiper-slide"
          v-for="(item, index) in CertificationList"
          :key="index"
        >
          <div class="certification_box">
            <img class="imgControl" :src="item.src" />
          </div>
        </swiper-slide>
      </swiper>
      <swiper
        :auto-update="true"
        class="certification-swiper PHONE"
        ref="certificationSwiper"
        :options="swiperOption4P"
      >
        <swiper-slide
          class="swiper-slide"
          v-for="(item, index) in CertificationList"
          :key="index"
        >
          <div class="certification_box">
            <img :src="item.src" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Swiper, SwiperSlide },
  data() {
    //这里存放数据
    return {
      Certification_title: "",

      CertificationList: [],

      swiperOption4P: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 33,
        speed: 500,
        autoplay: true,
      },
      swiperOption4: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,
        slidesPerGroup: 1,
        slidesPerView: 4,
        spaceBetween: 33,
        speed: 500,
        autoplay: true,
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var that = this;
    // 获取产品分类
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      async: false,
      data: {
        act: "article_list",
        category_id: 4,
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          that.Certification_title = obj.yj_name;
          if (obj.data) {
            $.each(obj.data, function (i, k) {
              if (k.pic_erweima[0]) {
                that.CertificationList.push({
                  src: k.pic_erweima[0],
                });
              }
            });
          }
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.Certification {
  width: 100%;
  background-color: #f4f4f4;
  .Certification_main {
    width: 100%;
    padding: 80px 9.25rem 80px;
    h1 {
      font-size: 2.1rem;
      font-weight: bold;
      color: #39404a;
      text-align: center;
    }
    .PHONE {
      display: none;
    }
    .certification-swiper {
      margin-top: 60px;
      .certification_box {
        width: 100%;
        border-radius: 5px;
        img {
          width: 100%;
          border-radius: 5px;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .Certification {
    padding: 20px 0;
    .Certification_main {
      max-width: 380px;
      margin: 0 auto;
      padding: 20px 10px 20px;
      .PC {
        display: none;
      }
      .PHONE {
        margin-top: 40px;
        display: block;
        .certification_box {
          width: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Certification.vue